export default defineTemplateMeta( {
  middleware: ["isn-auth", "hack-clear-basket"],
} );
